import { render } from "./UserPermission.vue?vue&type=template&id=0da4023d&scoped=true&ts=true"
import script from "./UserPermission.vue?vue&type=script&lang=ts"
export * from "./UserPermission.vue?vue&type=script&lang=ts"

import "./UserPermission.vue?vue&type=style&index=0&id=0da4023d&lang=scss&scoped=true"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da4023d"],['__file',"src/views/modules/admin/views/UserPermission.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0da4023d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0da4023d', __exports__)) {
    api.reload('0da4023d', __exports__)
  }
  
  module.hot.accept("./UserPermission.vue?vue&type=template&id=0da4023d&scoped=true&ts=true", () => {
    api.rerender('0da4023d', render)
  })

}


export default __exports__